<template>
  <div ref="splitview" class="smart splitview" :class="{open:paneOpen, hover:hoverOpen, [modeClass]:true}">
    <div class="pane">
        <slot name="pane"/>
    </div>
    <div class="content">
        <slot name="content"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartSplitView',
  props:{
      paneOpen:{
          type: Boolean,
          default: true
      },
      hoverOpen:{
          type: Boolean,
          default: false
      },
      overlayMode:{
          type: Boolean,
          default: false
      },
      compactMode:{
          type: Boolean,
          default: false
      },
      paneWidth:{
          type: String,
          default: null
      },
      paneCompactWidth:{
          type: String,
          default: null
      }
  },
  computed:{
      modeClass(){
        if(this.compactMode)
            return this.overlayMode ? "compact-overlay" : "compact-inline";
        return this.overlayMode ? "overlay" : "inline";
      }
  },
  watch:{
      paneWidth(newValue, oldValue){
            if(newValue === oldValue)
                return;
            this.setCssProp("--pane-width", newValue);
      },
      paneCompactWidth(newValue, oldValue){
            if(newValue === oldValue)
                return;
            this.setCssProp("--pane-compact-width", newValue);
      },
  },
  methods:{
      setCssProp(propName, value){
        this.$refs.splitview.style.setProperty(propName, value);
      }
  },
  mounted(){
      this.setCssProp("--pane-compact-width", this.paneCompactWidth);
      this.setCssProp("--pane-width", this.paneWidth);
  }
}
</script>

<style>
.smart.splitview {
    display: grid;
    grid-template-columns: min-content 1fr;
    grid-template-rows: 1fr;

    width: 100%;
}

.smart.splitview > .pane{
    background: var(--pane-background);
    transition: width ease-in-out 200ms;
    overflow: hidden;

    grid-row: 1;
    z-index: 1;

    position: relative;
    
    box-shadow: var(--pane-border);
}

.smart.splitview > .content{
    background: var(--content-background);

    grid-row: 1;
}

/* Inline Section*/
/* .splitview.inline {
    
} */

.smart.splitview.inline > .pane {
    width: 0;
}

/* .splitview.inline > .content {
    
} */


/* Overlay Section*/
.smart.splitview.overlay {
    grid-template-columns: 1fr;
}

.smart.splitview.overlay > .pane {
    width: 0;
    grid-column: 1;
}

.smart.splitview.overlay > .content {
    grid-column: 1;
}

/* Compact Inline Section*/
/* .splitview.compact-inline {
    
} */

.smart.splitview.compact-inline > .pane {
    width: var(--pane-compact-width);
}

/*.splitview.compact-inline > .content {
    
} */


/* Compact Overlay Section*/
.smart.splitview.compact-overlay {
    grid-template-columns: var(--pane-compact-width) 1fr;
}

.smart.splitview.compact-overlay > .pane {
    width: var(--pane-compact-width);
}

/*.splitview.compact-overlay > .content {
    
} */

/* Open Section*/
.smart.splitview.hover > .pane:hover,
.smart.splitview.open > .pane
{
    width: var(--pane-width);
}
</style>